module.exports = __webpack_public_path__ + "img/profession_occupation.4d5b970d.svg";